import { Body } from '@sumup/circuit-ui';
import { withNoMargin } from '../hocs';

const NoMarginBody = withNoMargin(Body);

export { NoMarginBody as Body };
